// extracted by mini-css-extract-plugin
export var backdropBlur = "_lj-0";
export var contentCard = "_lj-5";
export var frame = "_lj-2";
export var image = "_lj-4";
export var imagePane = "_lj-3";
export var modal = "_lj-1";